import axios from 'src/common/razzle-platform-components/axios'
import {
    AxiosHeaders,
    IRequestFetcherOptions
} from 'src/common/razzle-platform-components/types'
import {BASE_API_URL, SPECIFICITY_OF_PRODUCT_API_END_POINT} from 'src/common/razzle-platform-specificityofproduct/configs'



export const fetchSpecificitiesOfProduct = async (options: Pick<IRequestFetcherOptions, 'params'>, headers: AxiosHeaders={}) => {

    const params = options.params || {}

    const response = await axios.get(`${BASE_API_URL}${SPECIFICITY_OF_PRODUCT_API_END_POINT}`, {params, headers})

    return { specificitiesOfProduct: response.data }
}
